module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 5);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var COMMON_SYSTEM_MESSAGE_REQUEST = exports.COMMON_SYSTEM_MESSAGE_REQUEST = 'COMMON_SYSTEM_MESSAGE_REQUEST';
  var COMMON_SYSTEM_MESSAGE_FAILURE = exports.COMMON_SYSTEM_MESSAGE_FAILURE = 'COMMON_SYSTEM_MESSAGE_FAILURE';
  var RESET_SYSTEM_MESSAGES = exports.RESET_SYSTEM_MESSAGES = 'RESET_SYSTEM_MESSAGES';
  var GET_SYSTEM_MESSAGES_SUCCESS = exports.GET_SYSTEM_MESSAGES_SUCCESS = 'GET_SYSTEM_MESSAGES_SUCCESS';
  var SAVE_ARRAY = exports.SAVE_ARRAY = 'SAVE_ARRAY';
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _actions = __webpack_require__(4);

  var actions = _interopRequireWildcard(_actions);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var mapDispatchToProps = _extends({}, actions);

  exports.default = mapDispatchToProps;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var mapStateToProps = function mapStateToProps(state) {
    var _state$messagingSyste = state.messagingSystemDefinition,
        messagingSystemDefinition = _state$messagingSyste === undefined ? {} : _state$messagingSyste;
    var systemMessages = messagingSystemDefinition.systemMessages,
        _messagingSystemDefin = messagingSystemDefinition.alertVisibleArray,
        alertVisibleArray = _messagingSystemDefin === undefined ? [] : _messagingSystemDefin,
        _messagingSystemDefin2 = messagingSystemDefinition.messageArray,
        messageArray = _messagingSystemDefin2 === undefined ? [] : _messagingSystemDefin2,
        isFetching = messagingSystemDefinition.isFetching,
        _messagingSystemDefin3 = messagingSystemDefinition.error,
        error = _messagingSystemDefin3 === undefined ? null : _messagingSystemDefin3;
    return {
      systemMessages: systemMessages,
      alertVisibleArray: alertVisibleArray,
      messageArray: messageArray,
      isFetching: isFetching,
      error: error
    };
  };

  exports.default = mapStateToProps;
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _types = __webpack_require__(0);

  var messagingSystemDefinition = function messagingSystemDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case _types.RESET_SYSTEM_MESSAGES:
        return _extends({}, state, {
          isFetching: action.isFetching,
          systemMessages: action.systemMessages,
          alertVisibleArray: action.alertVisibleArray,
          messageArray: action.messageArray,
          error: action.error
        });

      case _types.COMMON_SYSTEM_MESSAGE_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.GET_SYSTEM_MESSAGES_SUCCESS:
        return _extends({}, state, {
          systemMessages: action.systemMessages,
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.SAVE_ARRAY:
        return _extends({}, state, {
          alertVisibleArray: action.alertVisibleArray,
          messageArray: action.messageArray
        });

      case _types.COMMON_SYSTEM_MESSAGE_FAILURE:
      default:
        return state;
    }
  };

  exports.default = messagingSystemDefinition;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.fetchSystemMessagesIfNeeded = exports.shouldFetchSystemMessages = exports.getSystemMessages = exports.saveSytemMessageArray = exports.getSystemMessagesSuccess = exports.commonSystemMsgFailure = exports.commonSystemMsgRequest = exports.resetSystemMessages = undefined;

  var _interact = __webpack_require__(6);

  var _types = __webpack_require__(0);

  var resetSystemMessages = exports.resetSystemMessages = function resetSystemMessages() {
    return {
      type: _types.RESET_SYSTEM_MESSAGES,
      isFetching: false,
      error: null,
      alertVisibleArray: [],
      messageArray: [],
      systemMessages: null
    };
  };
  /* Get System Messages */


  var commonSystemMsgRequest = exports.commonSystemMsgRequest = function commonSystemMsgRequest() {
    return {
      type: _types.COMMON_SYSTEM_MESSAGE_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var commonSystemMsgFailure = exports.commonSystemMsgFailure = function commonSystemMsgFailure(error) {
    return {
      type: _types.COMMON_SYSTEM_MESSAGE_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var getSystemMessagesSuccess = exports.getSystemMessagesSuccess = function getSystemMessagesSuccess(json) {
    return {
      type: _types.GET_SYSTEM_MESSAGES_SUCCESS,
      systemMessages: json,
      isFetching: false,
      error: null
    };
  };

  var saveSytemMessageArray = exports.saveSytemMessageArray = function saveSytemMessageArray(visibleArray, messageArray) {
    return {
      type: _types.SAVE_ARRAY,
      alertVisibleArray: visibleArray,
      messageArray: messageArray
    };
  };

  var getSystemMessages = exports.getSystemMessages = function getSystemMessages(request) {
    return function (dispatch) {
      dispatch(commonSystemMsgRequest());
      return fetch(_interact.Connection.baseUrl('messaging') + 'v1.0/system/getmessages', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify(request)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(getSystemMessagesSuccess(json));
      }).catch(function (error) {
        return dispatch(commonSystemMsgFailure(error));
      });
    };
  };

  var shouldFetchSystemMessages = exports.shouldFetchSystemMessages = function shouldFetchSystemMessages(state) {
    if (!state.systemMessages || !state.systemMessages.ExpiryDate) {
      return true;
    }

    var expiry = state.systemMessages.ExpiryDate;
    return new Date() > new Date(expiry);
  };

  var fetchSystemMessagesIfNeeded = exports.fetchSystemMessagesIfNeeded = function fetchSystemMessagesIfNeeded(request) {
    return function (dispatch, getState) {
      if (shouldFetchSystemMessages(getState().messagingSystemDefinition)) {
        return dispatch(getSystemMessages(request));
      }
    };
  };
  /***/

},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.mapDispatchToProps = exports.mapStateToProps = exports.messagingSystemDefinition = undefined;

  var _reducer = __webpack_require__(3);

  var _reducer2 = _interopRequireDefault(_reducer);

  var _mapStateToProps = __webpack_require__(2);

  var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);

  var _mapDispatchToProps = __webpack_require__(1);

  var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.messagingSystemDefinition = _reducer2.default;
  exports.mapStateToProps = _mapStateToProps2.default;
  exports.mapDispatchToProps = _mapDispatchToProps2.default;
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("@myie/interact");
  /***/
}
/******/
]);